/** Pure prize-tier helpers. */
import { uid } from './random.js';

export const MAX_QUANTITY = 100;

export function createTier(name = 'New tier', prize = '', quantity = 1) {
  return { id: uid(), name, prize, quantity };
}

export function defaultTiers() {
  return [createTier('Tier 1 · Grand Prize', 'Grand prize', 1)];
}

/** Winners that count toward a tier (voided winners free up their slot). */
export function activeWinners(tierId, winners) {
  return winners.filter((w) => w.tierId === tierId && !w.voided);
}

export function tierFilled(tier, winners) {
  return activeWinners(tier.id, winners).length;
}

export function isTierFull(tier, winners) {
  return tierFilled(tier, winners) >= tier.quantity;
}

/** Every prize has been drawn (false when there are no tiers at all). */
export function allTiersFull(tiers, winners) {
  return tiers.length > 0 && tiers.every((tier) => isTierFull(tier, winners));
}

/** Lowest quantity a tier may be set to without orphaning winners. */
export function minQuantity(tier, winners) {
  return Math.max(1, tierFilled(tier, winners));
}

export function clampQuantity(value, tier, winners) {
  const n = Math.round(Number(value));
  if (!Number.isFinite(n)) return tier.quantity;
  return Math.min(MAX_QUANTITY, Math.max(minQuantity(tier, winners), n));
}

/**
 * The tier to draw next: the current one if it still has slots, otherwise the
 * next unfilled tier after it (wrapping), otherwise null (all prizes drawn).
 */
export function nextOpenTierId(tiers, winners, currentId) {
  const start = Math.max(0, tiers.findIndex((t) => t.id === currentId));
  for (let offset = 0; offset < tiers.length; offset++) {
    const tier = tiers[(start + offset) % tiers.length];
    if (!isTierFull(tier, winners)) return tier.id;
  }
  return null;
}

export function moveTier(tiers, id, direction) {
  const index = tiers.findIndex((t) => t.id === id);
  const target = index + direction;
  if (index < 0 || target < 0 || target >= tiers.length) return tiers;
  const out = [...tiers];
  [out[index], out[target]] = [out[target], out[index]];
  return out;
}
